import { render, staticRenderFns } from "./startReview.vue?vue&type=template&id=0885f29e&scoped=true&"
import script from "./startReview.vue?vue&type=script&lang=js&"
export * from "./startReview.vue?vue&type=script&lang=js&"
import style0 from "./startReview.vue?vue&type=style&index=0&id=0885f29e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0885f29e",
  null
  
)

export default component.exports